<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <rect x="5.5" y="10.5" width="13" height="10" rx="2" stroke="currentColor" stroke-width="1.75" />
  <path
    d="M8.5 10.5V8.5C8.5 6.29086 10.2909 4.5 12.5 4.5C14.7091 4.5 16.5 6.29086 16.5 8.5V10.5"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
</svg>
